import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useNavigate, useParams } from "@tanstack/react-router";
import { useStaffQuery, useUpdateStaff } from "../api/queries";
import { StaffForm } from "../ui/StaffForm";

export function StaffEditPage() {
  const { id } = useParams({ from: "/app/performance/staff/$id/edit" });
  const nav = useNavigate({ from: "/app/performance/staff/$id/edit" });
  const { data: staff, isLoading } = useStaffQuery(id);
  const updateStaff = useUpdateStaff(id);

  if (isLoading || !staff) {
    return (
      <>
        <Header>
          <Breadcrumb
            items={[
              { label: "Staff", to: "/app/performance/staff" },
              { label: "..." },
            ]}
          />
        </Header>
        <Main>
          <p className="text-muted-foreground">ກຳລັງໂຫຼດ...</p>
        </Main>
      </>
    );
  }

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "Staff", to: "/app/performance/staff" },
            { label: staff.displayName },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">
            ແກ້ໄຂ: {staff.displayName}
          </h2>
        </div>

        <div className="rounded-xl border bg-card px-6">
          <StaffForm
            isEdit
            initialValues={{
              displayName: staff.displayName,
              defaultRoleLabel: staff.defaultRoleLabel ?? "",
              bankName: staff.bankName ?? "",
              bankAccount: staff.bankAccount ?? "",
              accountName: staff.accountName ?? "",
              phone: staff.phone ?? "",
              notes: staff.notes ?? "",
              performerId: staff.performerId ?? null,
              status: staff.status,
            }}
            onSubmit={async (vals) => {
              try {
                await updateStaff.mutateAsync(vals);
                nav({ to: "/app/performance/staff" });
              } catch {}
            }}
            onCancel={() => nav({ to: "/app/performance/staff" })}
            submitting={updateStaff.isPending}
          />
        </div>
      </Main>
    </>
  );
}
